/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Upload_Online_OnlyInputs */



/**
* | output |
* | --- |
* | "Recording upload is only available in online mode." |
*
* @param {Audio_Recorder_Upload_Online_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_upload_online_only = /** @type {((inputs?: Audio_Recorder_Upload_Online_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Upload_Online_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le téléversement de l'enregistrement est disponible uniquement en mode en ligne.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Hochladen von Aufnahmen ist nur im Online-Modus möglich.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il caricamento delle registrazioni è disponibile solo in modalità online.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка записи доступна только в онлайн-режиме.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La carga de grabaciones solo está disponible en modo en línea.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("录像上传仅支持在线模式。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("録画のアップロードはオンライン モードでのみ利用できます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्डिंग अपलोड करने की सुविधा केवल ऑनलाइन मोड में ही उपलब्ध है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O envio de gravações só está disponível no modo online.")
	return /** @type {LocalizedString} */ ("Recording upload is only available in online mode.")
});